import { ListQuestion } from "./list-question";
import { QuestionSetLabel } from "./question-set-label";
import { QuestionType } from "app/shared/models/question-type";

export class MultipleChoiceQuestion extends ListQuestion 
{
    private _answer:QuestionSetLabel;

    constructor() {
		super();
		this.type = QuestionType.MultipleChoice;
    }

	
	public get answer() : QuestionSetLabel {
		return this._answer;
	}
	
	
	public set answer(v : QuestionSetLabel) {
		this._answer = v;
	}

	public hasAnswer(ans:QuestionSetLabel) {
		return this.isAnswer(ans);
	}

	public get isFilledOut() : boolean {
		return this._answer != null;
	}

    isAnswer(ans:QuestionSetLabel) {
		if (this.answer) {
			return this.answer.id === ans.id;
		}
		return false;
	}

    public setSavedAnswer(answer:any, labels:QuestionSetLabel[]) {
        this.answer = labels.find(l => l.id == answer);
	}

	public get answerDisplayText() {
		if (!this.answer) {
			return "";
		}
        
        return this.answer.label;
	}

    public get answerForSave() {
		if (!this._answer) {
			return null;
		}
        return this._answer.id;
	}
}


// WEBPACK FOOTER //
// ./src/app/shared/models/multiple-choice-question.ts